import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Card, Badge, Button, Form, Modal } from "react-bootstrap";
import {
  MapPin,
  CheckCircle,
  Grid3x3,
  Search,
  Plus,
  ChevronRight,
  ArrowLeft,
  X,
} from "lucide-react";
import AdminMasterLayout from "../../../layouts/admin/AdminMasterLayout ";
import "../../../assets/styles/admin/AdminCityAreas.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const AdminCityAreas = () => {
  const [showAddCityModal, setShowAddCityModal] = useState(false);
  const [showAddAreaModal, setShowAddAreaModal] = useState(false);
  const [showCityAreas, setShowCityAreas] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [cityName, setCityName] = useState("");
  const [areaName, setAreaName] = useState("");
  const [areas, setAreas] = useState([]);
  const { baseUrl } = useContext(AppContext);

  const navigate = useNavigate();

  // Stats data
  const statsData = [
    {
      id: 1,
      title: "Total Cities",
      value: "6",
      icon: MapPin,
      iconBg: "#dbeafe",
      iconColor: "#2563eb",
    },
    {
      id: 2,
      title: "Active Cities",
      value: "5",
      icon: CheckCircle,
      iconBg: "#d1fae5",
      iconColor: "#059669",
    },
    {
      id: 3,
      title: "Total Areas",
      value: "13",
      icon: Grid3x3,
      iconBg: "#fef3c7",
      iconColor: "#f59e0b",
    },
  ];

  // Cities data
  // const cities () => {
  const [cities, setCities] = useState([]);

  const handleAddCity = () => {
    setShowAddCityModal(true);
  };

  const handleCloseAddCity = () => {
    setShowAddCityModal(false);
    setCityName("");
  };

  const addCity = (e) => {
    console.log("New city:", cityName);
    const formData = new FormData();
    formData.append("name", cityName);
    axios
      .post(`${baseUrl}/admin/city/addNewCity`, formData, {
        "Content-type": "multipart/form-data",
      })
      .then((response) => {
        if (response.data.success === true) {
          console.log(response.data.message);
          console.log(response.data);
          Swal.fire({
            title: "Congratulations!",
            text: response.data.message,
            icon: "success",
            confirmButtonText: "Cool",
          }).then(() => {
            handleCloseAddCity();
          });
        } else {
          console.log("error");
          Swal.fire({
            title: "Oops!",
            text: "Cannot add city at the moment",
            icon: "error",
            confirmButtonText: "Try Again",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong",
          icon: "error",
          confirmButtonText: "Try Again",
        });
      });
  };

  const handleViewCityAreas = (city) => {
    setSelectedCity(city);
    viewAllAreas(city);
    setShowCityAreas(true);
  };

  const handleBackToCities = () => {
    setShowCityAreas(false);
    setSelectedCity(null);
  };

  const handleAddArea = () => {
    setShowAddAreaModal(true);
  };

  const handleCloseAddArea = () => {
    setShowAddAreaModal(false);
    setAreaName("");
  };


  const handleCityToggle = (city) => {
  const formData = new FormData();
  formData.append("id", city.id);
  // formData.append("mwcity_id", city.id);

  axios.post(`${baseUrl}/admin/city/updateStatus`, formData)
    .then((res) => {
      Swal.fire("Done!", "City status updated", "success");
      viewAllCities();
    })
    .catch((err) => {
      console.log(err);
    });
};

const handleAreaToggle = (area) => {
  const formData = new FormData();
  formData.append("id", area.id);

  axios.post(`${baseUrl}/admin/area/updateStatus`, formData)
    .then((res) => {
      Swal.fire("Done!", "Area status updated", "success");
      viewAllAreas(selectedCity);
    })
    .catch((err) => {
      console.log(err);
    });
};


  const addArea = (e) => {
    console.log("New area:", areaName);
    const formData = new FormData();
    formData.append("name", areaName);
    formData.append("mwcity_id", selectedCity);
    axios
      .post(`${baseUrl}/admin/area/addNewArea`, formData, {header:{
        "Content-type": "multipart/form-data",
      }})
      .then((response) => {
        if (response.data.success === true) {
          console.log(response.data.message);
          console.log(response.data);
          Swal.fire({
            title: "Congratulations!",
            text: response.data.message,
            icon: "success",
            confirmButtonText: "Cool",
          }).then(() => {
            viewAllAreas(selectedCity);
            handleCloseAddArea(); //  modal close after success
          });
        } else {
          Swal.fire({
            title: "Oops!",
            text: "Cannot add area at the moment",
            icon: "error",
            confirmButtonText: "Try Again",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong",
          icon: "error",
          confirmButtonText: "Try Again",
        });
      });
  };

  const viewAllAreas = (cityId) => {
    console.log("city ID", cityId)
    const formData = new FormData();
    formData.append("mwcity_id", cityId.id);
    axios
      .post(`${baseUrl}/admin/area/viewAllAreas`, formData, {header:{
        'Content-type' : 'multipart-formdata'
      }})
      .then((response) => {
        console.log(response.data);
        if(response.data.success == true){
        if (response.data.areas != null) {
          console.log("all areas", response.data.areas);
          setAreas(response.data.areas);
        }

        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const viewAllCities = () => {
    axios
      .get(`${baseUrl}/admin/city/viewAllCities`)
      .then((response) => {
        if (response.data != null) {
          console.log("all Cities", response.data.cities);
          setCities(response.data.cities);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllCities();
    // viewAllAreas();
  }, []);

  if (showCityAreas && selectedCity) {
    return (
      <AdminMasterLayout>
        <div className="admin-city-areas-wrapper">
          {/* Areas Page Header */}
          <div className="admin-city-areas-detail-header">
            <div className="admin-city-areas-detail-left">
              <Button
                className="admin-city-areas-back-btn"
                onClick={handleBackToCities}
              >
                <ArrowLeft size={20} />
              </Button>
              <div>
                <h1 className="admin-city-areas-title">
                  {selectedCity.name} — Areas
                </h1>
                <p className="admin-city-areas-subtitle">
                  Manage areas within {selectedCity.name}
                </p>
              </div>
            </div>
            <Button
              className="admin-city-areas-add-btn"
              onClick={handleAddArea}
            >
              <Plus size={18} strokeWidth={2.5} />
              Add Area
            </Button>
          </div>

          {/* Areas Grid */}
          <Row className="admin-city-areas-grid g-3 g-lg-4">
            {/* {selectedCity.areasList.map((area, index) => ( */}
            {/* {areas? (<h1>No Record Found</h1>):( */}
            {areas.map((area, index) => (
              <Col xs={12} sm={6} lg={4} key={index}>
                <Card
                  className="admin-city-areas-area-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <Card.Body>
                    <div className="admin-city-areas-area-content">
                      <div className="admin-city-areas-area-left">
                        <div className="admin-city-areas-area-icon">
                          <MapPin size={20} />
                        </div>
                        <div>
                          <h4 className="admin-city-areas-area-name">
                            {area.name}
                          </h4>
                          <Badge
                            bg="primary"
                            className="admin-city-areas-area-badge"
                          >
                            {area.status}
                          </Badge>
                        </div>
                      </div>
                      {/* <Form.Check
                        type="switch"
                        className="admin-city-areas-area-switch"
                        defaultChecked={area.status === "active"}
                      /> */}
                      <Form.Check
                      type="switch"
                      className="admin-city-areas-area-switch"
                      checked={area.status === "active"}
                      onChange={() => handleAreaToggle(area)}
/>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Add Area Modal */}
          <Modal
            show={showAddAreaModal}
            onHide={handleCloseAddArea}
            centered
            className="admin-city-areas-modal"
          >
            <Modal.Header className="admin-city-areas-modal-header">
              <Modal.Title className="admin-city-areas-modal-title">
                Add New Area
              </Modal.Title>
              <button
                className="admin-city-areas-modal-close"
                onClick={handleCloseAddArea}
              >
                <X size={20} />
              </button>
            </Modal.Header>
            <Modal.Body className="admin-city-areas-modal-body">
              <Form>
                <Form.Group className="admin-city-areas-form-group">
                  <Form.Control
                    type="text"
                    placeholder="Area name..."
                    value={areaName}
                    onChange={(e) => setAreaName(e.target.value)}
                    className="admin-city-areas-form-input"
                    required
                  />
                </Form.Group>
                <Button
                  type="button"
                  className="admin-city-areas-submit-btn"
                  onClick={addArea}
                >
                  Add Area
                </Button>
              </Form>
            </Modal.Body>
          </Modal>
        </div>
      </AdminMasterLayout>
    );
  }

  return (
    <AdminMasterLayout>
      <div className="admin-city-areas-wrapper">
        {/* Page Header */}
        <div className="admin-city-areas-header">
          <div>
            <h1 className="admin-city-areas-title">City & Area Management</h1>
            <p className="admin-city-areas-subtitle">
              Manage cities and their service areas
            </p>
          </div>
          <div className="admin-city-areas-header-right">
            <div className="admin-city-areas-search-wrapper">
              <Search className="admin-city-areas-search-icon" size={20} />
              <Form.Control
                type="text"
                placeholder="Search cities..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="admin-city-areas-search-input"
              />
              {/* <Form.Check
              type="switch"
              className="admin-city-areas-area-switch"
              checked={area.status === "active"}
              onChange={() => handleAreaToggle(area)}
/> */}
            </div>
            <Button
              className="admin-city-areas-add-btn"
              onClick={handleAddCity}
            >
              <Plus size={18} strokeWidth={2.5} />
              Add City
            </Button>
          </div>
        </div>

        {/* Stats Cards */}
        <Row className="admin-city-areas-stats-row g-3 g-lg-4">
          {statsData.map((stat, index) => (
            <Col xs={12} sm={6} lg={4} key={stat.id}>
              <Card
                className="admin-city-areas-stat-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <Card.Body>
                  <div className="admin-city-areas-stat-content">
                    <div
                      className="admin-city-areas-stat-icon-box"
                      style={{ backgroundColor: stat.iconBg }}
                    >
                      <stat.icon
                        size={24}
                        style={{ color: stat.iconColor }}
                        strokeWidth={2}
                      />
                    </div>
                    <div className="admin-city-areas-stat-info">
                      <span className="admin-city-areas-stat-label">
                        {stat.title}
                      </span>
                      <h3 className="admin-city-areas-stat-value">
                        {stat.value}
                      </h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Cities Grid */}
        <Row className="admin-city-areas-grid g-3 g-lg-4">
          {cities.map((city, index) => (
            <Col xs={12} sm={6} lg={4} key={city.id}>
              <Card
                className="admin-city-areas-city-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <Card.Body>
                  <div className="admin-city-areas-city-header">
                    <div className="admin-city-areas-city-left">
                      <div className="admin-city-areas-city-icon">
                        <MapPin size={20} />
                      </div>
                      <div>
                        <h4 className="admin-city-areas-city-name">
                          {city.name}
                        </h4>
                        <span className="admin-city-areas-city-count">
                          {city.areas} areas
                        </span>
                        <h6 className="admin-city-areas-city-count mt-3">
                          Total Customers : 12
                        </h6>
                      </div>
                    </div>
                    {/* <Form.Check
                      type="switch"
                      className="admin-city-areas-city-switch"
                      defaultChecked={city.status === "active"}
                    /> */}
                    <Form.Check
                  type="switch"
                  className="admin-city-areas-city-switch"
                  checked={city.status === "active"}
                  onChange={() => handleCityToggle(city)}
/>
                  </div>
                  <div className="admin-city-areas-city-footer">
                    <Badge
                      bg={city.status === "active" ? "primary" : "success"}
                      className="admin-city-areas-city-badge"
                    >
                      {city.status}
                    </Badge>
                    <button
                      className="admin-city-areas-view-btn"
                      // onClick={() =>{ handleViewCityAreas(city); setSelectedCity(city.id)}}
                      onClick={() =>handleViewCityAreas(city)}
                    >
                      <ChevronRight size={18} />
                    </button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Add City Modal */}
        <Modal
          show={showAddCityModal}
          onHide={handleCloseAddCity}
          centered
          className="admin-city-areas-modal"
        >
          <Modal.Header className="admin-city-areas-modal-header">
            <Modal.Title className="admin-city-areas-modal-title">
              Add New City
            </Modal.Title>
            <button
              className="admin-city-areas-modal-close"
              onClick={handleCloseAddCity}
            >
              <X size={20} />
            </button>
          </Modal.Header>
          <Modal.Body className="admin-city-areas-modal-body">
            <Form>
              <Form.Group className="admin-city-areas-form-group">
                <Form.Control
                  type="text"
                  placeholder="City name..."
                  value={cityName}
                  onChange={(e) => setCityName(e.target.value)}
                  className="admin-city-areas-form-input"
                  required
                />
              </Form.Group>
              <Button
                type="button"
                className="admin-city-areas-submit-btn"
                onClick={addCity}
              >
                Add City
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    </AdminMasterLayout>
  );
};

export default AdminCityAreas;
